// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorPriceLists = (client) => ({
    /**
     * `POST /vendor/price-lists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPriceListsCreate
     * @source apps/backend/src/api/vendor/price-lists/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/price-lists", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/price-lists/:id/prices`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreatePriceListPrice
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/prices/route.ts
     */
    createPrice: (id, body, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id/prices", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRemoveProductsFromPriceList
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/products/route.ts
     */
    createProduct: (id, body, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id/products", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeletePriceListsId
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /vendor/price-lists/:id/prices/:price_id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeletePriceListPriceById
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/prices/[price_id]/route.ts
     */
    deletePrice: (id, priceId, body, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id/prices/:price_id", [id, priceId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/price-lists`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorPriceListsList
     * @source apps/backend/src/api/vendor/price-lists/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/price-lists", { method: "GET", query, headers }),
    /**
     * `GET /vendor/price-lists/:id/products`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListProductsInPriceList
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/products/route.ts
     */
    listProducts: (id, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id/products", [id]), { method: "GET", query, headers }),
    /**
     * `GET /vendor/price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPriceListById
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/price-lists/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdatePriceList
     * @source packages/modules/b2c-core/src/api/vendor/price-lists/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/price-lists/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=price-lists.js.map